import { FC } from 'react'

import { FF, FormType, RadioGroup, Select, TextareaInput } from 'ui/components'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { QuestionnaireDemo } from '../../../../../../types'
import * as SC from '../../../../style'

export const RepetitiveCashTransactions: FC<{ formApi: FormType<QuestionnaireDemo> }> = ({ formApi }) => {
  return (
    <>
      <FormRow>
        <Col2x>
          <SC.MainText>
            Deposits apparently structured to avoid Currency Transaction Report (CTR) requirements.
          </SC.MainText>
        </Col2x>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            Review the cash transactions for the current 90-day period for repetitive cash transactions around the
            $10,000 threshold.
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="repetitiveCashTransactionsReview"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name="repetitiveCashTransactionsStructuring"
            children={(field) => (
              <FF
                field={field}
                label="Has the business been structuring?"
                input={(p) => (
                  <Select
                    data={[
                      {
                        label: 'No Transactions of This Type',
                        value: 'no_transactions'
                      },
                      {
                        label: 'All Transactions Ok',
                        value: 'all_transactions_ok'
                      },
                      {
                        label: 'Transactions addressed with communication to customer during review',
                        value: 'transactions_addressed'
                      },
                      {
                        label: 'Other – See comments',
                        value: 'other'
                      }
                    ]}
                    {...p}
                  />
                )}
              />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col2x>
          <formApi.Field
            name="repetitiveCashTransactionsComments"
            children={(field) => (
              <FF field={field} label="Comments" input={(p) => <TextareaInput maxLength={5000} {...p} />} />
            )}
          />
        </Col2x>
      </FormRow>
    </>
  )
}
